import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

export const ServiceMarquee = ({ items, light = false }) => (
  <div
    data-testid="service-marquee"
    className={`overflow-hidden border-y py-5 ${light ? "border-white/10 bg-brand-deep" : "border-slate-200 bg-white"}`}
  >
    <Marquee speed={30} pauseOnHover gradient={false} aria-hidden="true">
      {items.map((item, i) => (
        <span key={i} className={`mx-8 flex items-center gap-8 font-display text-sm font-bold uppercase tracking-[0.3em] ${light ? "text-teal-100/70" : "text-slate-500"}`}>
          {item}
          <Sparkle className={`h-3.5 w-3.5 ${light ? "text-teal-300" : "text-brand-teal"}`} />
        </span>
      ))}
    </Marquee>
  </div>
);
